import debounce from "lodash.debounce";
import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import "./ManualInputs.scss";
import { TradeIn } from "Types/TradeIn";
import MaskedInput from "react-text-mask";

interface ManualInputsProps {
    tradePending: Partial<TradeIn>;
    uuid: string;
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
    patchTradePending: (tradePending: TradeIn, uuid: string) => void;
}

class ManualInputs extends React.Component<ManualInputsProps & WithTranslation> {
    //  TODO we really shouldn't be patching onchange with a debounce because slow typers will get an error if they type
    //   199 and pause (schema requires 4 digits). Increasing debounceTimeout as a temp fix
    protected debounceTimeout = 1500;
    protected debouncedOnChange = debounce((event: any) => {
        const eventField = event.target.id;
        const eventValue = event.target.value;
        this.props.patchTradePending({ [eventField]: eventValue }, this.props.uuid);
    }, this.debounceTimeout);

    public render() {
        const { t } = this.props;
        return (
            <div className="ManualInput__container" data-e2e="manualInputsContainer">
                <div className="ManualInput__container--header">
                    <span className="ManualInput__header--text">{t("TradePending.ManualInputs.header1")}</span>
                    <span className="ManualInput__header--text">{t("TradePending.ManualInputs.header2")}</span>
                </div>
                <div className="ManualInput__container--input">
                    <span className="ManualInput--title">{t("TradePending.ManualInputs.year")}</span>
                    <MaskedInput
                        className="ManualInput__input"
                        id="year"
                        mask={[/\d/, /\d/, /\d/, /\d/]}
                        guide={false}
                        onChange={this.handleOnChange}
                        placeholder={this.props.tradePending.year ?? ""}
                        type="string"
                        onFocus={this.handleOnInputFocus}
                    />
                </div>
                <div className="ManualInput__container--input">
                    <span className="ManualInput--title">{t("TradePending.ManualInputs.make")}</span>
                    <input
                        className="ManualInput__input"
                        id="make"
                        onChange={this.handleOnChange}
                        placeholder={this.props.tradePending.make ?? ""}
                        type="text"
                    />
                </div>
                <div className="ManualInput__container--input">
                    <span className="ManualInput--title">{t("TradePending.ManualInputs.model")}</span>
                    <input
                        className="ManualInput__input"
                        id="model"
                        onChange={this.handleOnChange}
                        placeholder={this.props.tradePending.model ?? ""}
                        type="text"
                    />
                </div>
                <div className="ManualInput__container--input">
                    <span className="ManualInput--title">{t("TradePending.ManualInputs.trim")}</span>
                    <input
                        className="ManualInput__input"
                        id="trim"
                        onChange={this.handleOnChange}
                        placeholder={this.props.tradePending.trim ?? ""}
                        type="text"
                    />
                </div>
            </div>
        );
    }

    protected handleOnChange = (event: any) => {
        event.persist();
        this.debouncedOnChange(event);
    };

    protected handleOnInputFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        this.props.onFocus && this.props.onFocus(e);
    };
}

export default withTranslation()(ManualInputs);
